<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Batch Water Readings</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <div class="block">
      <div class="screen_heading_div">
        <span>Batch Water Readings</span>
      </div>
      <div class="row">
        <div class="buttons-div dashboard-add-view">
          <div class="transactions-button-container"
               (click)="getBatchTransactions()" [ngClass]="currentComponent=='add'?'unselected-btn':'selected-btn'">
            <button class="transaction-submit-button">
                <span class="icon" style="align-items: center;"><img
                  src="../../../../../../assets/images/New_Icons/view-icon.svg"></span>
              <span class="text">View</span>
            </button>
          </div>
          <div class="transactions-button-container"
               [ngClass]="currentComponent=='list'?'unselected-btn':'selected-btn'" (click)="onGotoAddBatch()">
            <button class="transaction-submit-button" style="width: 155px">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
              <span class="text">Add New</span>
            </button>
          </div>
        </div>
      </div>
      <div class="Reports_form_div">
        <form role="form" name="addmapdevice" (clickOutside)="isDropdownOpen = false" class="form-horizontal">
          <div class="reports-form-container">
            <!--farm site-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location"  name="location" [(ngModel)]="farm_site_id" (selectionChange)="getSetionsByFarmsiteId(farm_site_id)">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--section-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Sections</mat-label>
              <mat-select id="section_id" name="section_id" [(ngModel)]="section_id" (selectionChange)="OnSectionSelection()">
                <mat-option value="undefined" disabled>Select Sections</mat-option>
                <mat-option *ngFor="let sections of pondSections" [value]="sections.id">
                  {{ (sections?.section_name) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div" *ngIf=" currentComponent=='list'"
             style="justify-content: right">
          <div class="transactions-button-container" (click)="getBatchTransactions()">
            <button class="transaction-submit-button" [disabled]="!business_id||!farm_site_id||!section_id">
              <span class="goicon"><img src="../../../../../../assets/images/New_Icons/go.svg"></span>
              <span class="text">Go</span>
            </button>
          </div>
        </div>
        <div *ngIf="currentWaterQualityPage">
          <app-batch-water-quality *ngIf=" currentComponent=='add' && section_id"
                                   (gotoWaterQualityList)="refreshList($event)"
                                   [businessId]="business_id"
                                   [businessName]="businessName"
                                   [siteId]="farm_site_id"
                                   [sectionId]="section_id"></app-batch-water-quality>
          <app-batch-water-quality-view *ngIf="currentComponent=='list'&&business_id&&farm_site_id&&section_id"
                                        [businessId]="business_id"
                                        [siteId]="farm_site_id"
                                        [sectionId]="section_id"></app-batch-water-quality-view>
        </div>
      </div>
    </div>
  </div>
</div>
